import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-signature",
  "use": "icon-signature-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-signature\"><path d=\"M955.3 935.3c0 22.6-18.3 41-41 41h-824c-22.6 0-41-18.3-41-41 0-22.6 18.3-41 41-41h824c22.7 0.1 41 18.4 41 41zM893.6 628.8H704.7l-54.9-127.4c67.4-45.2 111.7-122.1 111.7-209.3 0-139.2-112.8-252-252-252s-252 112.8-252 252c0 87.6 44.7 164.7 112.4 209.8l-54.7 126.9H112.7c-34 2.3-61.1 29.6-63.3 63.6v103.5c2.3 34.6 30.4 62.1 65.3 63.4h778.6c32.5-2.7 58.5-28.1 62.1-60.3V686.7c-4.6-31.1-30.2-55.4-61.8-57.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol